export default __webpack_public_path__ + "static/media/chevron-down.579c3644.svg";